export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">人气排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时更新的人气热度排名，发现当下最受漫迷追捧的优质漫画
          </p>
        </div>

        <div className="max-w-2xl mx-auto">

          <div className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/70 hover:bg-background-100 cursor-pointer transition-colors">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold bg-primary-500 text-background-50">1</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-heading font-semibold text-foreground-950 truncate">星辰恋语</span>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">恋爱</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs font-medium text-primary-600">🔥 98.5万</span>
              <span className="text-xs text-accent-600"><i className="ri-arrow-up-s-fill"></i></span>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/70 hover:bg-background-100 cursor-pointer transition-colors">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold bg-primary-300 text-background-50">2</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-heading font-semibold text-foreground-950 truncate">千秋岁</span>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">古风</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs font-medium text-primary-600">🔥 112.3万</span>
              <span className="text-xs text-accent-600"><i className="ri-arrow-up-s-fill"></i></span>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/70 hover:bg-background-100 cursor-pointer transition-colors">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold bg-secondary-400 text-background-50">3</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-heading font-semibold text-foreground-950 truncate">剑域风云</span>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">热血</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs font-medium text-primary-600">🔥 86.2万</span>
              <span className="text-xs text-accent-600"><i className="ri-arrow-up-s-fill"></i></span>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/70 hover:bg-background-100 cursor-pointer transition-colors">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold bg-background-200 text-foreground-600">4</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-heading font-semibold text-foreground-950 truncate">蜜糖陷阱</span>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">恋爱</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs font-medium text-primary-600">🔥 105.6万</span>
              <span className="text-xs text-foreground-400"><i className="ri-arrow-down-s-fill"></i></span>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 md:p-5 hover:bg-background-100 cursor-pointer transition-colors">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold bg-background-200 text-foreground-600">5</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-heading font-semibold text-foreground-950 truncate">暗夜追逐</span>
                <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-[10px] font-medium text-accent-700">悬疑</span>
              </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <span className="text-xs font-medium text-primary-600">🔥 74.8万</span>
              <span className="text-xs text-accent-600"><i className="ri-arrow-up-s-fill"></i></span>
            </div>
          </div>

        </div>

        <div className="text-center mt-8">
          <a href="#cards" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}